export default __webpack_public_path__ + "static/media/cavinimg.10114a13.jpg";